import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, HashRouter } from "react-router-dom";
import "./assets/style/reset.less";
import "./assets/style/common.less";
import "antd-mobile-v2/dist/antd-mobile.css";
import "./index.css";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import md5 from "js-md5";
React.Component.prototype.$md5 = md5;

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
